export const primaryUrl = 'https://server.mind-health.xyz';
export const primaryCdnUrl = 'https://cdn.mind-health.xyz';

export const backupUrl = 'https://mindhealthy.ru/-server-';
export const backupCdnUrl = 'https://mindhealthy.ru/-images-';

export const rootUrl = primaryUrl;
export const cdnUrl = primaryCdnUrl;

export const introDescription = 'У нас есть удобный сервис для психологов!';
